import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { userdocuments as documents  , UserCheckBoxData as checkBoxData} from './documents';
import { useFormik } from 'formik';
import { Button } from '@mui/material';
import CustomSelection from '../../../Components/SelectionComp/CustomSelection';
import { ParagraphComp } from '../../../Components/ParagraphComp/ParagraphComp';
import { InputCompo } from '../../../Components/InputCompo/InputCompo';
import CustomInput from '../../../Components/InputCompo/CustomInput';
import { enqueueSnackbar } from 'notistack';
import { useMutation } from '@tanstack/react-query';
import { EditDataUserCreateAccount } from '../../../Store/auth/createAccount';


const EditUserType = ({setActiveStep}) => {
    const navigate = useNavigate();
    const [selectedValue, setSelectedValue] = useState('');


    const modelSchema = Yup.object().shape(
      documents.reduce((schema, field) => {
          if (field.mandatory === 1 && field.type.toLowerCase() !== 'section') {
              let validator = Yup.string().required(`${field.question} is required`);
  
              if (field.validation) {
                  switch (field.validation.toLowerCase()) {
                      case 'email':
                          validator = Yup.string()
                              .email('Invalid email address')
                              .required(`${field.question} is required`);
                          break;
                      case 'number':
                          validator = Yup.string()
                              .matches(/^\d{10}$/, "Invalid Number. It should be 10 digit.")
                              .required(`${field.question} is required`);
                          break;
                      
                      default:
                          break;
                  }
              }
  
              schema[field.question_no] = validator;
          }
  
          return schema;
        }, {})
      );
  
      const formik = useFormik({
          initialValues: {
              ...documents.reduce((values, field) => {
                values[field.question_no] = '';
                return values;
              }, {}),
              ...checkBoxData.reduce((values, checkbox) => {
                  values[checkbox.name] = false;
                  return values;
                }, {}),
            },
  
          validationSchema: modelSchema,
          enableReinitialize: true,
          onSubmit: async (values, { setSubmitting }) => {
              try {
                  // Convert the form data into a flat object
                  const tempData = {
                      ...documents.reduce((acc, field) => {
                          acc[field.question_no] = values[field.question_no];
                          return acc;
                      }, {}),
                      ...checkBoxData.reduce((acc, checkbox) => {
                          if (checkbox.isCustomInput) {
                              // If the checkbox has an associated input field, save the input field's value
                              acc[checkbox.name] = values[checkbox.name];
                          } else {
                              // For normal checkboxes, save "Yes" or "No"
                              acc[checkbox.name] = values[checkbox.name] ? '1' : '0';
                          }
                          return acc;
                        }, {}),
                  };
              
                  // Retrieve existing data from localStorage
                  const existingData = JSON.parse(localStorage.getItem('createAccount')) || {};
              
                  // Merge new data with existing data
                  const updatedData = {
                      ...existingData,
                      ...tempData,
                  };
                  const structuredData = {
                    args: updatedData
                };
              
                  // Save updated data to localStorage
                  localStorage.setItem('createAccount', JSON.stringify(structuredData));
              
                  await submitReg(structuredData);
                  localStorage.removeItem('createAccount');

                  // Navigate back
                  navigate(-1);
  
                  // Optionally, navigate to the next page or perform another action
  
                } catch (error) {
                    console.error(error);
                } finally {
                    setSubmitting(false);
                }
          },
      });

    const handleCreateSuccess = () => {
        enqueueSnackbar('success!', { variant: 'success' });
        localStorage.clear('formData')
    };

    const handleCreateError = (error) => {
        if (error?.response?.data.status_code >= 500) {
            enqueueSnackbar(error?.response?.data?.status_message, { variant: 'error' });
        } else {
            enqueueSnackbar(error?.response?.data?.message || error?.message, { variant: 'error' });

        }
    };

    const createFarmerMutationOptions = {
        onSuccess: handleCreateSuccess,
        onError: handleCreateError,
    };

    const {
        mutate: submitReg,
        // data: regFinalData,
        // isPending: mainRegistration
    } = useMutation({
        mutationFn: EditDataUserCreateAccount,
        ...createFarmerMutationOptions,
    });


      const handleDropdownChange = (e) => {
        const value = e.target.value;
        formik.setFieldValue(documents[0].question_no, value);
        setSelectedValue(value);
      };
  return (
    <div>
        <form action="" onSubmit={formik.handleSubmit} className='flex gap-3 flex-col my-5 min-h-[60vh]'>

            <div className='flex flex-wrap gap-[30px] justify-between w-[100%] mt-2'>
                    {documents?.slice(0, 1).map(Fields =>
                    <>
                            {Fields.type.toLowerCase() === 'dropdown'
                                ?
                                <div className='w-[100%]'>
                                    <>
                                        <CustomSelection required={Fields.mandatory} options={Fields?.options}
                                            {...formik?.getFieldProps(Fields?.question_no)}
                                            onChange={handleDropdownChange}
                                            name={Fields.question_no} label={Fields.question}
                                        />
                                        {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                                        <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                                </div>
                                :''
                            }
                    </>
                    )}
                </div>

               

                {selectedValue === "Individual" && 
                    <>
                         <div className='my-4'>
                            <ParagraphComp className='font-semibold text-lg' text='(Multi select for individuals)' />
                        </div>
                        <div className='w-[100%] flex gap-[24pt] flex-wrap'>
            
                            {checkBoxData?.slice(0,16).map((item, index) => (
                            <div className='w-[40%] flex gap-[24pt]' key={index}>
                            {!item.isCustomInput?
                            <div className='w-[100%]'>
                                <label className="flex items-center space-x-2">
                                <InputCompo 
                                    className='bg-[#004878] text-white w-[20px] h-[20px]' 
                                    type='checkbox' 
                                    name={item.name}
                                    checked={formik.values[item.name]} 
                                    onChange={formik.handleChange} 
                                    onBlur={formik.handleBlur} 
                                />
                                <span className='text-black'>{item.label}</span>
                                </label>
                                <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.touched[item.name] && formik.errors[item.name]} />
                            </div>
                                :<>
                                {item.isCustomInput && (
                                <div className='w-[100%]'>
                                    <label className="flex items-center space-x-2">
                                    <InputCompo 
                                    className='bg-[#004878] text-white w-[20px] h-[20px]' 
                                    type='checkbox' 
                                    name={item.name}
                                    checked={formik.values[item.name]} 
                                    onChange={formik.handleChange} 
                                    onBlur={formik.handleBlur} 
                                />
                                    <CustomInput 
                                        required={item.mandatory} 
                                        {...formik.getFieldProps(item.name)} 
                                        name={item.name} 
                                        label={item.label} 
                                        onBlur={formik.handleBlur} 
                                    />
                                    </label>
                                    <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={formik.touched[item.name] && formik.errors[item.name]} />
                                </div>
                                )}</>}
                            </div>
                            ))}
                        </div>
                    </>
                }

                {selectedValue === "Institutional/Group" && 
                    <>
                         
                        
                        <div className='flex flex-wrap gap-[30px] justify-between w-[100%] mt-2'>
                            {documents?.slice(1, 2).map(Fields =>
                            <>
                                    {Fields.type.toLowerCase() === 'dropdown'
                                        ?
                                        <div className='w-[100%]'>
                                            <>
                                                <CustomSelection required={Fields.mandatory} options={Fields?.options}
                                                    {...formik?.getFieldProps(Fields?.question_no)}
                                                    name={Fields.question_no} label={Fields.question}
                                                />
                                                {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                                                <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                                        </div>
                                        :''
                                    }
                            </>
                            )}
                        </div>

                        <div className='flex flex-wrap gap-[30px] justify-between w-[100%] my-4'>
                            {documents?.slice(2, 3).map(Fields =>
                            <>
                                    {Fields.type.toLowerCase() === 'text'
                                        ?
                                        <div className='w-[100%]'>
                                            <>
                                                <CustomInput required={Fields.mandatory}  
                                                    {...formik?.getFieldProps(Fields?.question_no)}
                                                    
                                                    name={Fields.question_no} label={Fields.question}
                                                />
                                                {/* <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={TempFormik?.values?.[Fields.question_no] && TempFormik?.errors?.[Fields.question_no]} /> */}
                                                <ParagraphComp className='mt-[8px] text-[#5A5A5A] text-sm px-[8px]' text={Fields.description} />                                        </>
                                        </div>
                                        :''
                                    }
                            </>
                            )}
                        </div>
                    </>
                }


                <div className='flex justify-end'>
                    <div className='flex gap-[20px]'>
                        {/* <Button onClick={() => navigate(-1)} variant='text' disableRipple sx={{color:'#ED1C24' , fontWeight:600 , textTransform:'inherit' , letterSpacing:'-.5px' , fontSize:'14px'}}>Cancel</Button> */}
                        <Button type='submit' variant='contained' sx={{backgroundColor:'#ED1C24' , color:'white' , borderRadius:'20px', fontWeight:600 , textTransform:'inherit' , letterSpacing:'-.5px' , fontSize:'14px' , '&:hover':{backgroundColor:'#ED1C24'}}}>Submit</Button>
                    </div>
                </div>
            </form>
    </div>
  )
}

export default EditUserType